import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {Router} from '@angular/router';
import {UrlBuilderService} from '../services/url-builder.service';
import {QueryParams} from '../types/QueryParams';

@Directive({
  selector: '[appAddClickActionToLocalLinks]',
})
export class AddClickActionToLocalLinksDirective implements OnInit, OnDestroy {
  private unlistenFunctions: Array<() => void> = [];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private urlBuilder: UrlBuilderService
  ) {}

  ngOnInit(): void {
    const links = this.elementRef.nativeElement.getElementsByTagName('a');
    for (let i = 0; i < links.length; i++) {
      this.unlistenFunctions.push(
        this.renderer.listen(links[i], 'click', (event) =>
          this.handleLinkClick(event)
        )
      );
    }
  }

  ngOnDestroy(): void {
    this.unlistenFunctions.forEach((unlisten) => unlisten());
  }

  handleLinkClick(event: Event): void {
    const href = (event.target as HTMLAnchorElement).href;
    const convertedUrl: [string[], QueryParams] =
      this.urlBuilder.convertUrlToRouterLink(href);
    if (convertedUrl !== null) {
      event.preventDefault();
      this.router.navigate(convertedUrl[0], {
        queryParams: convertedUrl[1],
      });
    }
  }
}
